import React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const PdfViewer = ({ url }) => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div className="w-full h-full border border-gray-300 rounded-lg overflow-hidden flex flex-col items-center justify-center bg-gray-200 relative">
            <div style={{ height: '100%', width: '100%', position: 'absolute', inset: 0 }}>
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                    <Viewer
                        fileUrl={url}
                        plugins={[defaultLayoutPluginInstance]}
                        renderError={(error) => (
                            <div className="flex flex-col items-center justify-center p-8 text-center h-full absolute inset-0 z-50 bg-gray-100">
                                <span className="text-4xl mb-4">⚠️</span>
                                <p className="text-red-600 font-bold max-w-sm mb-4">Unable to view PDF inside the browser due to CORS/security restrictions.</p>
                                <a href={url} target="_blank" rel="noreferrer" className="bg-[#5928ed] text-white px-6 py-2 rounded-full font-bold inline-block hover:bg-purple-800 transition">
                                    Download / View PDF Externally
                                </a>
                            </div>
                        )}
                        renderLoader={() => (
                            <div className="flex flex-col items-center justify-center h-full absolute inset-0 z-50 text-gray-500 font-semibold gap-3">
                                <span className="animate-spin text-2xl">⏳</span> Loading PDF...
                            </div>
                        )}
                    />
                </Worker>
            </div>
        </div>
    );
};

export default PdfViewer;
